export default __webpack_public_path__ + "static/media/0195.7377ed12.jpg";